// Framework
import { Component } from '@angular/core';
// ngx-bootstrap
import { BsModalRef } from 'ngx-bootstrap/modal';
// Services
import { DataService } from '../../services/data.service';
import { MomentService } from '../../services/moment.service';

// Providers
import { AngularFirestore } from '@angular/fire/firestore';

import * as moment from 'moment';

@Component({
    selector: 'contract-terms-modal',
    templateUrl: './contract-terms-modal.component.html',
})

export class ContractTermsModalComponent {

    /*
        This Terms Modal is used in One placee.

        1. Potential school completing their agreement
    */

    setUpStartDate: Date;
    
    constructor (
        private afs: AngularFirestore,
        public dataSvc: DataService,
        public bsModalRef: BsModalRef,
        private momentSvc: MomentService
    ) { 
        let cpSetupFee: any = dataSvc.daycare.fees.cpSetupFee;
        this.setUpStartDate = this.dataSvc.getJSDate(cpSetupFee.startDate);
        this.setUpStartDate = (this.setUpStartDate > new Date() ? this.setUpStartDate : new Date());
    }
    
    // Determine if the school is a free trial school upgrading their account
    isFreeTrialUpgrade() {
        return this.dataSvc.daycare && !!this.dataSvc.daycare.freeTrial;
    }

    // TX FCCN Partnership schools sign the real partnership agreement — no pricing shown, no
    // auto-renewal, no early-termination fee — instead of the standard pricing contract terms above.
    // Delegates to DataService so this and sign-up-auth agree on what counts as a TX FCCN school.
    isTxFccnFree(): boolean {
        return this.dataSvc.isTxFccnFree();
    }

    // The agreement ties the 12-month coverage window to the date it's signed, not to
    // fees.cpBillingStartDate (a separate, staff-configured field) — this is a pre-signature
    // preview, so estimate "today + 12 months" rather than reusing getRenewalDate()'s anchor.
    getTxFccnCoverageEndDate(): string {
        const today = new Date();
        return new Date(today.getFullYear() + 1, today.getMonth(), today.getDate()).toLocaleDateString();
    }

    getDate(date: any) {
        return this.momentSvc.getMoment(date).toDate();
        // if(date && (date.seconds || date._seconds)) {
        //     return date.toDate();
        // }
        // else {
        //     return new Date(date);
        // }
    }

    dismissModal() {
        this.bsModalRef.hide();
    }

    getCPSetupFeeDetail(cpSetupFee: any) {
        if(cpSetupFee) {
            let amount: any = cpSetupFee.amount;
            let partialAmount: any = cpSetupFee.partialAmount;
            if (amount && partialAmount && this.setUpStartDate) {
                return Math.floor(parseFloat(amount)/parseFloat(partialAmount)) + " payments of $" + partialAmount + " starting on " + this.setUpStartDate.toLocaleDateString() + " for a total of $" + amount;
            }
            else {
                return "$"+this.numberToCurrency(amount);
            }
        }
    }

    getFirstBillingInvoiceDate(billingStartDate: any) {
        let todayMom = moment(billingStartDate);

        return todayMom.clone().add(1,'M').startOf('M').toDate();
    }
    // getFirstBillingInvoiceDate(billingStartDate) {
    //     let nextMonthDate = new Date(new Date().getFullYear(), new Date(this.dataSvc.getJSDate(billingStartDate)).getMonth()+1,1);
    //     let firstInvoicingDate = new Date(nextMonthDate.getFullYear(), nextMonthDate.getMonth(), nextMonthDate.getDate()-1);
    //     return firstInvoicingDate;
    // }

    getMerchantRatesStatement() {
        // if(this.dataSvc.daycare.fees.merchantTerms == "FlatRate" && this.dataSvc.daycare.fees.credit) {
            return "a flat rate of <span class='bolded'>" + (this.dataSvc.daycare.fees.credit.value ? this.dataSvc.daycare.fees.credit.value: "0.00") + "% </span> per transaction on all MC, VISA, Discover, and Amex types. The merchant includes a <span class='bolded'>$" + this.dataSvc.daycare.fees.merchantFee + "</span> monthly statement fee and $120.00 anual fee (anual fee not applied until January " + new Date().getFullYear+1 + ").";
        // }
    }

    getRenewalDate() {
        return new Date(new Date(this.dataSvc.getJSDate(this.dataSvc.daycare.fees.cpBillingStartDate)).getFullYear()+1, new Date(this.dataSvc.getJSDate(this.dataSvc.daycare.fees.cpBillingStartDate)).getMonth(), new Date(this.dataSvc.getJSDate(this.dataSvc.daycare.fees.cpBillingStartDate)).getDate()).toLocaleDateString();
    }

    numberToCurrency(num: number) {
        let number = Number(num)
        return (number).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }

    getYear() {
        return new Date().getFullYear() + 1;
    }

    printElement() {
        let elem = document.getElementById('print-this')
        var domClone = elem.cloneNode(true);

        var $printSection = document.createElement("div");
        $printSection.id = "printSection";
        document.body.appendChild($printSection);
    
        $printSection.appendChild(domClone);
        window.print();
    }
}